import { useState, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

import { FaIcon, NgButton } from '@/ui';
import { buildDiagnosticReport } from '@/lib/diagnostics';
import { dismissUnhandledError, getUnhandledError, subscribeToUnhandledErrors } from '@/lib/errors/unhandledErrors';
import type { UnhandledError } from '@/lib/errors/unhandledErrors';

export function UnhandledErrorBar() {
  const { t } = useTranslation();
  const error = useSyncExternalStore(subscribeToUnhandledErrors, getUnhandledError);
  const [copiedError, setCopiedError] = useState<UnhandledError | null>(null);

  if (error === null) {
    return null;
  }

  const copyError = async () => {
    await navigator.clipboard.writeText(
      buildDiagnosticReport({
        error: error.detail,
        errorOccurredAt: error.occurredAt,
        errorPageUrl: error.pageUrl,
      }),
    );
    setCopiedError(error);
  };

  return (
    <div className="unhandled-error-bar" role="alert">
      <div className="d-flex gap-3 align-items-start">
        <div className="d-flex flex-column flex-lg-row gap-2 align-items-lg-center flex-grow-1">
          <div className="flex-grow-1">{t('Blazor_UnhandledError_Info')}</div>

          <NgButton
            icon="fal fa-rotate"
            text={t('Blazor_UnhandledError_Refresh')}
            onClick={() => window.location.reload()}
          />

          <NgButton
            icon="fal fa-copy"
            text={copiedError === error ? t('Tooltip_CopiedToClipboard') : t('Blazor_UnhandledError_Copy')}
            onClick={copyError}
          />
        </div>

        <button
          type="button"
          className="unhandled-error-bar__dismiss btn btn-link p-0"
          aria-label={t('Button_Close')}
          onClick={dismissUnhandledError}
        >
          <FaIcon icon="fal fa-xmark" />
        </button>
      </div>
    </div>
  );
}
